<template>
    <Structure_Header_Col2 icon="fa-video">
        <template v-slot:col-1>
            <Header_Name
                :name="video.name"
                type="Movie"
                @save="saveName"
            />
        </template>
        <template v-slot:col-2>
            <Header_Tools
                type="video"
            />
        </template>
    </Structure_Header_Col2>
</template>

<script>
import Structure_Header_Col2 from "@/views/structures/Structure_Header_Col2";
import Header_Name from "@/views/header/Header_Name";
import Template from "@/layouts/Template";
import Header_Tools from "@/views/header/Header_Tools";
export default {
    name: "Video_Header",
    components: {Header_Tools, Template, Header_Name, Structure_Header_Col2},
    props:{
        video:Object,
    },
    methods:{
        saveName(name){
            this.video.name = name;
            this.video.patch("name")
        }
    }
}
</script>